import React, { Component } from 'react';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { withStyles } from '@material-ui/core/styles';

import { AccentColor } from 'helpers/AccentColorHelper';

const styles = theme => ({
  bnRoot: {
    background: 'rgba(0,0,0,0.05)',
    height: '76px',
    marginBottom: '15px',
  },
  bnaRoot: {
    maxWidth: 'unset',
    borderRadius: '0 !important',
    fontSize: '23px !important',
    padding: 0,
  },
  bnaSelected: {
    fontSize: '13px',
    background: '#e8e9e8',
    paddingTop: '0 !important',
    color: AccentColor(),
  },
  bnaIconOnly: {},
  bnaLabel: {
    fontSize: '14px !important',
    fontFamily: 'Circular',
    textTransform: 'none',
  },
  bnaWrapper: {
    padding: '9px',
  },
});

class ButtonSwitchNavigation extends Component {
  state = {
    selectedIndex: 0,
  };

  handleChange = (_event, selectedIndex) => {
    this.setState({ selectedIndex: selectedIndex });
    this.props.handleChange(selectedIndex);
  };

  render() {
    const { classes, buttonLabels, buttonIcons } = this.props;
    const navigationCount = Math.max(buttonLabels.length, buttonIcons.length);
    const bnClasses = {
      root: classes.bnRoot,
    };
    const bnaClasses = {
      root: classes.bnaRoot,
      selected: classes.bnaSelected,
      iconOnly: classes.bnaIconOnly,
      label: classes.bnaLabel,
      wrapper: classes.bnaWrapper,
    };

    return (
      <BottomNavigation
        showLabels
        value={this.state.selectedIndex}
        onChange={this.handleChange}
        classes={bnClasses}
      >
        {Array.from(Array(navigationCount)).map((_item, i) => {
          return (
            <BottomNavigationAction
              key={`nav-${i}`}
              classes={bnaClasses}
              label={buttonLabels.length >= i + 1 && buttonLabels[i]}
              icon={buttonIcons.length >= i + 1 && buttonIcons[i]}
            />
          );
        })}
      </BottomNavigation>
    );
  }
}

export default withStyles(styles)(ButtonSwitchNavigation);
